$mol_icon_align_horizontal_distribute $mol_icon path \M4 22H2V2H4V22M22 2H20V22H22V2M13.5 7H10.5V17H13.5V7Z
